import { Component } from "../component"
import { iterable } from "../helpers/iterable"

export class Modal extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      open: "-open",
      modalOpen: "-modal-open",
      active: "-active",
    }
  }

  ui() {
    return {
      parts: ".modal-part",
      partSwitcher: ".modal-part-switcher",
    }
  }

  toggle() {
    const { open, modalOpen } = this.dynamicClasses
    const modalInput = this.$el.querySelector(".text-input")

    this.$el.classList.toggle(open)
    document.body.classList.toggle(modalOpen)

    if (this.$el.classList.contains(open)) {
      this.toggleParts(0)
      if (modalInput) {
        setTimeout(() => {
          modalInput.focus()
        }, 250)
      }
    }
  }

  toggleParts(partIndex = 0) {
    const { parts } = this.$ui
    const { active } = this.dynamicClasses

    iterable(parts).forEach((part, index) => {
      part.classList.toggle(active, index === partIndex)
    })
  }

  attachEvents() {
    const { partSwitcher } = this.$ui
    const { open } = this.dynamicClasses
    const id = this.$el.id
    const links = document.querySelectorAll(
      `.modal-toggle[href="#${id}"], .ui-modal-close[data-modal-id="${id}"]`
    )

    iterable(links).forEach((link) => {
      link.addEventListener("click", (e) => {
        this.toggle()
        e.preventDefault()
      })
    })

    iterable(partSwitcher).forEach((switcher) => {
      switcher.addEventListener("click", (e) => {
        this.toggleParts(parseInt(switcher.dataset.partIndex))
        e.preventDefault()
      })
    })

    window.addEventListener("keyup", (e) => {
      if (e.code === "Escape" && this.$el.classList.contains(open)) {
        this.toggle()
      }
    })
  }

  created() {
    this.attachEvents()
  }
}
